import { UsersClient } from '@empathybroker/tsclient-users';

import { ActionContext } from 'vuex';

import { CrudDataTypeEnum } from '../../../enums';

import { ActionClass, ContextState, CrudState } from '../../../models';

import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { FetchDataAction } from '../../../store/crud/actions/fetch-data.action';
import { CRUD_CONSTS } from '../../../store/crud/crud.consts';

export class SetEnabledAction implements ActionClass {

  public static execute({ commit, state, rootGetters }: ActionContext<CrudState, any>,
    payload: { dataType: CrudDataTypeEnum, items: any[], enabled: boolean }): Promise<any[]> {
    commit(CRUD_CONSTS.mutations.setState, {
      dataType: payload.dataType
    });

    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const serviceClient = FetchDataAction.getServiceClient(payload.dataType, context);
    const authToken: string = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.token }`];
    return new Promise((resolve, reject) => {
      Promise.all(SetEnabledAction.getServiceRequests(payload.dataType, serviceClient, authToken, payload.items, payload.enabled))
        .then((responses: any[]) => {
          const data = state.data.map((dataItem: any) => {
            const payloadDataItem = payload.items.find((item: any) => (item.id === dataItem.id));
            if (!!payloadDataItem) {
              payloadDataItem.enabled = payload.enabled;
              return payloadDataItem;
            } else {
              return dataItem;
            }
          });
          commit(CRUD_CONSTS.mutations.setState, {
            data: data
          });
          resolve(responses);
        })
        .catch(reject);
    });
  }

  private static getServiceRequests(dataType: CrudDataTypeEnum, serviceClient: UsersClient, authToken: string, items: any[],
    enabled: boolean): Promise<any>[] {
    if (dataType === CrudDataTypeEnum.USERS) {
      return items.map((item: any) => serviceClient.setEnabled(authToken, item.id, enabled));
    } else {
      throw new Error('Not valid datatype. Only USERS.');
    }
  }

}
